import React from 'react';
import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import './Meal.css'

const Meal = (props) => {
  const {food_name, price, food_image, _id} = props.time;
  const history = useHistory()
  const handleClick = (id) => {
    history.push(`/meal/${id}`)
  }
    return (
    <Card style={{ width: '21rem', height: '26rem', border: 'none', borderRadius: '10px' }} className="card-container" onClick={() => handleClick(_id)}>
      <Card.Img variant="top" src={food_image} style={{padding: '10px 50px'}}/>
      <Card.Body className="text-center">
        <Card.Title><b>{food_name}</b></Card.Title>
        <Card.Text style={{color: '#888888'}}>
          how we dream about our future
        </Card.Text>
        <h4><b>${price}</b></h4>
      </Card.Body>
    </Card>  

    );
};

export default Meal;